import React from 'react';
import CSVDownloadQrsButton from '../../../../Components/Buttons/CSVDownloadQrsButton/CSVDownloadQrsButton';
import { getEventLink, validateUserRole } from '../../../../utils/utils';
import { USER_PERMISSIONS } from '../../../../constants/types';

export const infoCards = ({ user, event }) => {
  const { id: eventId, producerId, name: eventName, endDate } = event;

  const currentDate = new Date().toISOString();
  const eventIsActive = endDate > currentDate;

  return [
    {
      title: 'Abrir en la web',
      text: 'Accedé al link público del evento tal como lo ven los usuarios',
      buttonText: 'Abrir en la web',
      link: getEventLink(event, user, event.Producer?.customDomain?.url),
      icon: 'calendar-3',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.BACKOFFICE),
      newTab: true,
    },
    {
      title: 'Reportes',
      text: 'Consultá las ventas y métricas principales de este evento',
      buttonText: 'Ver reportes',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/reportes`,
      icon: 'clipboard-2',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.BACKOFFICE),
    },
    {
      title: 'Editar información del evento',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/editar`,
      text: 'Cambiá nombre, imagen, fecha, estado y otros datos principales',
      buttonText: 'Editar evento',
      icon: 'pencil',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.ADMIN),
    },
    {
      title: 'Gestionar tickets',
      text: 'Creá o editá tickets e invitaciones, incluyendo precio, stock y reglas',
      buttonText: 'Gestionar tickets',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/tickets`,
      icon: 'ticket',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.ADMIN),
    },
    {
      title: 'Crear administrador o vendedor',
      text: 'Agregá personas para ayudar a gestionar el evento',
      buttonText: 'Crear usuario',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/crearUsuario`,
      icon: 'people-add',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.ADMIN) && eventIsActive,
    },
    {
      title: 'Asignar a RRPPs',
      text: 'Permití que los RRPPs envíen invitaciones a sus contactos',
      buttonText: 'Asignar a RRPPs',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/asignarInvitaciones`,
      icon: 'group',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.ADMIN),
    },
    {
      title: 'Enviar invitaciones',
      text: 'Generá y compartí invitaciones individuales para este evento',
      buttonText: 'Enviar invitaciones',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/enviarInvitaciones`,
      icon: 'email-2',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.SELLERS),
    },
    {
      title: 'Enviar múltiples invitaciones',
      text: 'Cargá un archivo CSV para crear muchas invitaciones juntas',
      buttonText: 'Importar CSV',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/enviarMultiplesInvitaciones`,
      icon: 'diamond-shine',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.ADMIN),
    },
    {
      title: 'Gestionar blacklist',
      text: 'Bloqueá o permití la visibilidad del evento para distintos usuarios',
      buttonText: 'Gestionar blacklist',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/blacklist`,
      icon: 'eye-slash',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.ADMIN),
    },
    {
      title: 'Crear venta en efectivo',
      text: 'Realizá órdenes en efectivo para este evento',
      buttonText: 'Crear venta',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/ventaCash`,
      icon: 'banknote-1',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.SELLER_WITH_CASH),
    },
    {
      title: 'Ver órdenes',
      text: 'Consultá las órdenes, pagos y accesos de este evento',
      buttonText: 'Ver órdenes',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/ordenes`,
      icon: 'planning',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.ADMIN),
    },
    {
      title: 'Duplicar evento',
      text: 'Copiá este evento con sus mismos tickets y configuraciones',
      buttonText: 'Duplicar evento',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/duplicar`,
      icon: 'square-behind-square-2',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.ADMIN),
    },
    {
      title: 'Descargar QRs',
      text: 'Descargá un csv con la información de los QRs de las entradas vendidas del evento',
      buttonText: 'Descargar',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/reportes`,
      icon: 'arrow-box-left',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.ADMIN_WITH_READ_ONLY),
      button: <CSVDownloadQrsButton eventId={eventId} eventName={eventName} />,
    },
    {
      title: 'Gestionar promociones',
      text: 'Gestioná promociones de este evento',
      buttonText: 'Gestionar promociones',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/promociones`,
      icon: 'tag',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.SUPER_ADMIN),
    },
    {
      title: 'Liquidaciones',
      text: 'Cargá adelantos, servicios, rebates, y liquidaciones del evento',
      buttonText: 'Cargar liquidaciones',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/liquidaciones`,
      icon: 'bank',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.SUPER_ADMIN),
    },
    {
      title: 'Opciones avanzadas',
      text: 'Opciones avanzadas del evento',
      buttonText: 'Editar opciones avanzadas',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/opcionesAvanzadas`,
      icon: 'settings-gear-2',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.SUPER_ADMIN),
    },
    {
      title: 'Gestionar artistas',
      text: 'Gestioná los artistas de tu evento.',
      buttonText: 'Gestionar artistas',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/artistas`,
      icon: 'audio',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.ADMIN),
    },
    {
      title: 'Ver métodos de pago',
      text: 'Ver los métodos de pago de tu evento.',
      buttonText: 'Ver métodos de pago',
      link: `/backoffice/productoras/${producerId}/eventos/${eventId}/metodosDePago`,
      icon: 'credit-card-1',
      permissions: validateUserRole(user.role, USER_PERMISSIONS.SUPER_ADMIN),
    },
  ];
};
